module.exports = __webpack_public_path__ + "img/3.5e5f6cf5.webp";